var _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ba0c2f",
    d: "M0 0h22v16H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0h4v16H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6h22v4H0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#00205b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0h2v16H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7h22v2H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorway);
export default __webpack_public_path__ + "static/media/norway.f170b2f3d5f82a3198c3a28c09bc5785.svg";
export { ForwardRef as ReactComponent };